import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { handleCallNewsApp, h5PageCount } from 'ThreeTerminal_utils';
import { SimpleGuideLayer } from 'ThreeTerminal_mobile_dynamic';
import errorBoundary from '@ifeng-fe/errorBoundary';

class FixedIcon extends PureComponent {
    static propTypes = {
        type: PropTypes.string,
        link: PropTypes.string,
        clientLink: PropTypes.string,
        image: PropTypes.string,
        pageType: PropTypes.string,
        base62Id: PropTypes.string,
    };

    state = {
        isCloseFixed: false,
        isShowGuideLayer: false,
        isActive: false,
    };

    isScroll = true;

    componentDidMount() {
        let scrollTimer = null;

        window.addEventListener('load', () => {
            document.addEventListener('scroll', () => {
                clearTimeout(scrollTimer);
                this.scrollStart();
                scrollTimer = setTimeout(this.scrollEnd, 3000);
            });
        });
    }

    scrollStart = () => {
        if (this.isScroll) {
            this.setState({
                isActive: true,
            });
        }
        this.isScroll = false;
    };

    scrollEnd = () => {
        this.isScroll = true;
        this.setState({
            isActive: false,
        });
    };

    closeGuideLayer = () => {
        const { link } = this.props;
        const { pageType, base62Id } = this.props;

        h5PageCount([
            {
                behavior: 'action',
                type: 'lamb_cancelentry',
                other: {
                    ref: `ucms_${base62Id}`,
                    kind: pageType,
                },
            },
        ]);

        this.setState({
            isShowGuideLayer: false,
        });
        // setTimeout(() => {
        //     location.href = link;
        // }, 50);
    };

    gotoHandle = () => {
        const { type, link, pageType, base62Id } = this.props;

        h5PageCount([
            {
                behavior: 'action',
                type: 'lamb',
                other: {
                    ref: `ucms_${base62Id}`,
                    kind: pageType,
                },
            },
        ]);

        if (type === '1') {
            setTimeout(() => {
                location.href = link;
            }, 50);
        }
        if (type === '2') {
            this.setState({
                isShowGuideLayer: true,
            });
        }
        if (type === '3') {
            this.callupClient();
        }
    };
    gotoCallupClient = () => {
        const { pageType, base62Id } = this.props;

        h5PageCount([
            {
                behavior: 'action',
                type: 'lamb_enter',
                other: {
                    ref: `ucms_${base62Id}`,
                    kind: pageType,
                },
            },
        ]);

        this.setState({
            isShowGuideLayer: false,
        });

        this.callupClient();
    };

    callupClient = () => {
        const { link, clientLink } = this.props;
        const url = clientLink || link || '';

        handleCallNewsApp(
            '',
            'web',
            url,
            '',
            0,
            0,
            'inter_fxy10',
            {
                noPrefixKind: true,
            },
            {
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1451915130996',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8795',
            },
        );
    };

    closeHandle = () => {
        this.setState({
            isCloseFixed: true,
        });
    };

    render() {
        /**
         * 组件分发数据
         */
        const { type, image } = this.props;
        let { isCloseFixed, isShowGuideLayer, isActive } = this.state;

        if (type === '4') {
            isCloseFixed = true;
        }

        return (
            <Fragment>
                {!isCloseFixed && (
                    <div className={`${styles.fixedIcon} ${isActive ? styles.active : ''}`}>
                        <img className={styles.fixedIconImg} onClick={this.gotoHandle} src={image} />
                        <img
                            className={styles.fixedIconClose}
                            onClick={this.closeHandle}
                            src="https://x0.ifengimg.com/cmpp/2020/0218/2e8863428fa47c0size2_w35_h35.png"
                        />
                    </div>
                )}
                <SimpleGuideLayer
                    isShowGuideLayer={isShowGuideLayer}
                    unfoldType={'2'}
                    unfoldTextInfo={{}}
                    closeGuideFn={this.closeGuideLayer}
                    gotoClientFn={this.gotoCallupClient}
                />
            </Fragment>
        );
    }
}

export default errorBoundary(FixedIcon);
